<template>
  <div class="breadcrumb-com">
   <img src="../../../../assets/images/BTOC/dh.png" alt="">
   <div @click="goUrl(title.path)">{{title.label}}</div>
   <i class="el-icon-d-arrow-right"></i>
    <div @click="goUrl(nextTitle.path)">{{nextTitle.label}}</div>
   <i class="el-icon-d-arrow-right"></i>
   <div class="clickUrl" @click="goUrl()">{{info.label}}</div>
  </div>
</template>

<script>
export default {
  props:["info","title",'nextTitle'],
  methods:{
    goUrl(url=info.path){
      this.$router.push(url)
    }
  }
};
</script>

<style scoped>
.breadcrumb-com{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-top: 230px;
}
.breadcrumb-com img{
  margin-right: 6px;
  width: 20px;height: 20px;
}
.breadcrumb-com div{
  height: 24px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #54595d;
  line-height: 24px;
  cursor: pointer;
}
i{
  margin-top: 4px;
  margin-left: 6px;
  margin-right: 6px;
}
.breadcrumb-com .clickUrl{
  height: 24px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #3682ed;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Policies/Detail/Crumbs.vue